module.exports = __webpack_public_path__ + "static/victory-87f5e654f5a1cc30bf0d453e5c4b0c74.gif";